(() => {
  if (window.sttokeBenefitsCarouselReady) return;
  window.sttokeBenefitsCarouselReady = true;
  const initialise = () => {
    document.querySelectorAll('.js-get-mcwi-section').forEach(section => {
      const carousel = section.querySelector('.js-swiper-mcwi-carousel');
      if (!carousel || carousel.swiper || typeof Swiper === 'undefined') return;
      const previous = section.querySelector('[data-mcwi-prev]');
      const next = section.querySelector('[data-mcwi-next]');
      const status = section.querySelector('.mcwi-status');
      const update = swiper => {
        if (previous) previous.disabled = swiper.isBeginning || swiper.isLocked;
        if (next) next.disabled = swiper.isEnd || swiper.isLocked;
        if (status) status.textContent = swiper.slides.length ? `${swiper.activeIndex + 1} / ${swiper.slides.length}` : '';
      };
      const swiper = new Swiper(carousel, {
        slidesPerView: 1.4,
        spaceBetween: 16,
        slidesOffsetAfter: 20,
        watchOverflow: true,
        grabCursor: true,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 350,
        navigation: { prevEl: previous, nextEl: next },
        breakpoints: {
          768: { slidesPerView: 2.1, spaceBetween: 16 },
          990: { slidesPerView: 2.1, spaceBetween: 24 }
        },
        on: { init: update, slideChange: update, update, resize: update, lock: update, unlock: update }
      });
      carousel.tabIndex = 0;
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); swiper.slideNext(); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); swiper.slidePrev(); }
      });
    });
  };
  const sync = event => {
    const id = String(event?.detail?.variant?.id || document.querySelector('.main-product-section form[id^="product-form-"] input[name="id"]')?.value || '');
    if (!id) return;
    document.querySelectorAll('.js-get-mcwi-section').forEach(section => {
      const template = section.querySelector(`template[data-variant-slides="${CSS.escape(id)}"]`);
      if (!template || section.dataset.currentVariant === id) return;
      section.dataset.currentVariant = id;
      const carousel = section.querySelector('.js-swiper-mcwi-carousel');
      const wrapper = carousel.querySelector('.swiper-wrapper');
      const image = section.querySelector(`template[data-variant-main-image="${CSS.escape(id)}"]`);
      wrapper.replaceChildren(template.content.cloneNode(true));
      section.querySelector('.multicolumn-with-image-main_image_wrapper').replaceChildren(...(image ? [image.content.cloneNode(true)] : []));
      section.style.display = wrapper.querySelector('.swiper-slide') ? '' : 'none';
      initialise();
      if (carousel.swiper) {
        carousel.swiper.update();
        carousel.swiper.slideTo(0, 0);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', () => { initialise(); sync(); });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.js-swiper-mcwi-carousel').forEach(el => el.swiper?.destroy(true, true)));
  document.addEventListener('variant:change', sync);
  document.addEventListener('change', () => { sync(); setTimeout(sync, 150); setTimeout(sync, 500); });
})();
